import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../store/slices/pageSlice";
import Header from "../components/header/Header";
import DepositLayout from "./DepositLayout";
import WithdrawLayout from "./WithdrawLayout";
import HistoryLayout from "./HistoryLayout";
import BalanceActionsBar from "../components/BalanceActionsBar";

export default function PaymentLayout() {
    const dispatch = useDispatch();
    const paymentType = useSelector((state) => state.payment?.type || 'deposit'); // 'deposit', 'withdraw', 'history'
    const selectedPromo = useSelector((state) => state.selectedPromo?.promo);

    const handleClose = () => {
        dispatch(setPage({ id: 6, name: 'balance' }));
    };

    const getTitle = () => {
        switch (paymentType) {
            case 'deposit':
                return 'Deposit';
            case 'withdraw':
                return 'Withdraw';
            case 'history':
                return 'History';
            default:
                return 'Payment';
        }
    };

    const renderContent = () => {
        switch (paymentType) {
            case 'deposit':
                return <DepositLayout />;
            case 'withdraw':
                return <WithdrawLayout />;
            case 'history':
                return <HistoryLayout />;
            default:
                return <DepositLayout />;
        }
    };

    return (
        <div className={'w-full h-full flex flex-col overflow-hidden'}>
            <div className="pt-[24px] pb-[10px] flex-shrink-0">
                <Header
                    leftButtonText="Close"
                    centerTitle={getTitle()}
                    onLeftClick={handleClose}
                    useBackIcon={false}
                />
            </div>
            <div className="flex-1 overflow-y-auto min-h-0">
                {renderContent()}
            </div>
            {!selectedPromo && <BalanceActionsBar />}
        </div>
    );
}
